import { render, staticRenderFns } from "./DetectionListDetail.vue?vue&type=template&id=63fc0ca0"
import script from "./DetectionListDetail.vue?vue&type=script&lang=js"
export * from "./DetectionListDetail.vue?vue&type=script&lang=js"
import style0 from "./DetectionListDetail.vue?vue&type=style&index=0&id=63fc0ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports